import { Suspense, useState } from 'react'
import { Outlet } from 'react-router'

import { SectionLoader } from '@/components/common/FullPageLoader'
import { DesktopSidebar, MobileSidebar } from '@/components/layout/Sidebar'
import { Topbar } from '@/components/layout/Topbar'

/** Chrome shared by every authenticated route. */
export function AppLayout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false)

  return (
    <div className="flex min-h-dvh">
      <DesktopSidebar />
      <MobileSidebar open={mobileNavOpen} onOpenChange={setMobileNavOpen} />

      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar onOpenMobileNav={() => setMobileNavOpen(true)} />
        {/* 1120px column, as the design lays it out. */}
        <main className="mx-auto w-full max-w-[1120px] flex-1 px-4 pt-4 pb-18">
          <Suspense fallback={<SectionLoader />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </div>
  )
}
